import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Checkbox from "../checkbox/Checkbox";
import SimpleErrorMessage from "../error-message/new-error-message";

type TermsAndConditionsCheckboxProps = {
  isError: boolean;
  onClick: () => void;
};

function TermsAndConditionsCheckbox({
  isError = false,
  onClick = (): void => void 0,
}: TermsAndConditionsCheckboxProps) {
  const [t] = useTranslation();
  const history = useHistory();
  const goToTermsAndConditions = (anchor?: string) => {
    if (anchor) anchor = "#" + anchor;
    history.push("/terms-and-conditions" + anchor);
  };

  const ANCHOR_TermsAndConditions = "termsandconditions0";
  const ANCHOR_PrivacyPolitics = "termsandconditions1";

  return (
    <div className="flex flex-col justify-center mt-2 items-center gap-4">
      <div className="flex w-full">
        <Checkbox
          ariaLabel="Declaro que aceito os Termos e Condições e que li a Informação sobre o Tratamento de Dados Pessoais"
          onClick={onClick}
          isError={isError}
        />
        <div className="terms-and-conditions-checkbox-div text-sm text-[var(--on-surface-default)]">
          <span aria-hidden={true}>{t("common.accept_terms_message1")}{" "}</span>
          <span
            role="link"
            onClick={() => goToTermsAndConditions(ANCHOR_TermsAndConditions)}
            className="underline cursor-pointer text-[var(--on-surface-primary-default-variant)] hover:text-[var(--on-surface-primary-hover-variant)] pressed:text-[var(--on-surface-primary-pressed-variant)] disabled:text-[var(--on-surface-variant-2)]"
          >
            <b>{t("common.accept_terms_message2")}</b>
          </span>{" "}
          <span aria-hidden={true}>{t("common.accept_terms_message3")}{" "}</span>
          <span
            role="link"
            onClick={() => goToTermsAndConditions(ANCHOR_PrivacyPolitics)}
            className="underline cursor-pointer text-[var(--on-surface-primary-default-variant)] hover:text-[var(--on-surface-primary-hover-variant)] pressed:text-[var(--on-surface-primary-pressed-variant)] disabled:text-[var(--on-surface-variant-2)]"
          >
            <b>{t("common.accept_terms_message4")}</b>
          </span>
        </div>
      </div>
      {isError && <SimpleErrorMessage error={t("common.accept_terms_error")} />}
    </div>
  );
}

export default TermsAndConditionsCheckbox;